<template>
  <tr>
    <td>
      <v-icon small>mdi-timeline-text-outline</v-icon>
      <v-avatar v-if="item.procedure === 'produced'">
        <img class="header-img pa-1" src="@/assets/img/illustrations/production.png" alt="vial">
      </v-avatar>
      <v-avatar v-if="item.procedure === 'production'">
        <img class="header-img pa-1" src="@/assets/img/illustrations/production.png" alt="vial">
      </v-avatar>
      <v-avatar v-if="item.procedure === 'delivery'">
        <img class="header-img pa-1" src="@/assets/img/illustrations/package.png" alt="package">
      </v-avatar>
      <v-avatar v-if="item.procedure === 'sale'">
        <img class="header-img pa-1" src="@/assets/img/illustrations/purse.png" alt="money bag">
      </v-avatar>
      <v-avatar v-if="item.procedure === 'sample'">
        <img class="header-img pa-1" src="@/assets/img/illustrations/sample.png" alt="money bag">
      </v-avatar>
      <v-avatar v-if="item.procedure === 'custom transaction'" size="36px" style="background: linear-gradient(30deg, #EF9958, #DB4572);">
        <v-icon color="white">mdi-timeline-text-outline</v-icon>
      </v-avatar>
    </td>
    <td class="caption">
      {{ dateHuman }} <br /> ({{ date }})
    </td>
    <td class="caption">
      <v-menu v-if="$store.state.settings.debugMode" offset-x open-on-hover>
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            small
            color="grey"
            v-on="on"
          >
            <v-icon small>mdi-android-debug-bridge</v-icon>
          </v-btn>
        </template>
        <v-card outlined class="elevation-0">
          <v-layout class="backgroundCard pa-2 caption">
            JSON
          </v-layout>
          <div class="c-hr"></div>
          <div class="pa-3">
            <span class="caption">
              {{ item }}
            </span>
          </div>
        </v-card>
      </v-menu>

      <div v-if="item.procedure === 'delivery'">
        Item delivered.<br/>
        <router-link
        class="underline-link"
        :to="{ path: '/delivery/' + item.meta.delivery_id}" @click.native.stop>
          delivery
          {{ item.meta.delivery_id }}
        </router-link>
      </div>

      <div v-else-if="item.procedure === 'produced'">
        Item produced.<br/>
        <router-link
        class="underline-link"
        :to="{ path: '/production/' + item.meta.production_id}" @click.native.stop>
          production
          {{ item.meta.production_id }}
        </router-link>
      </div>

      <div v-else-if="item.procedure === 'production'">
        Used in production.
        <div>
          <v-avatar v-if="item.meta.stage === 0" size="12" color="purple"></v-avatar>
          <v-avatar v-else-if="item.meta.stage === 1" size="12" color="blue"></v-avatar>
          <v-avatar v-else-if="item.meta.stage === 2" size="12" color="green"></v-avatar>
          &nbsp;
          <span v-if="item.meta.stage === 0" class="textSecondary--text">Qued</span>
          <span v-else-if="item.meta.stage === 1" class="textSecondary--text">In process</span>
          <span v-else-if="item.meta.stage === 2" class="textSecondary--text">Complete</span>
        </div>
        <router-link
        v-if="item.meta.production_id"
        class="underline-link"
        :to="{ path: '/production/' + item.meta.production_id}" @click.native.stop>
          Production
          {{ item.meta.production_id }}
        </router-link>
      </div>

      <div v-else-if="item.procedure === 'sale'">
        Sold.<br />
        <router-link
        v-if="item.meta.sale_id"
        class="underline-link"
        :to="{ path: '/sale/' + item.meta.sale_id}" @click.native.stop>
          sale
          {{ item.meta.sale_id }}
        </router-link>
      </div>

      <div v-else-if="item.procedure === 'sample'">
        Moved to sample cabinet.<br />
      </div>

      <div v-else-if="item.procedure === 'custom transaction'">
        Custom transaction.<br/>
        <router-link
        class="underline-link"
        :to="{ path: '/inventory-tx/' + item.meta.inventory_tx_id}" @click.native.stop>
          tx
          {{ item.meta.inventory_tx_id }}
        </router-link>
      </div>

      <div v-else>
        {{ item.description }}
      </div>

      <v-icon color="pink" v-if="item.error" small>mdi-alert</v-icon>

    </td>
    <td>
      <c-ms-ii
      :metric_definition="definition" 
      :realValue="item.quantity"
      :key="item.quantity"
      :prefferedSid="prefferedSid"
      labelMode
      :class="item.quantity < 0 ? 'red--text' : 'green--text'"
      ></c-ms-ii>
    </td>
  </tr>
</template>

<script>
export default {
  props: ['item', 'definition', 'prefferedSid'],
  computed: {
    date () {
      if (this.$moment.utc(this.item.date).isValid()) {
        return this.$moment(this.item.date).format('DD MMM YYYY')
      }
      return ''
    },
    dateHuman () {
      if (this.$moment.utc(this.item.date).isValid()) {
        return this.$moment.utc(this.item.date).fromNow()
      }
      return ''
    }
  }
}
</script>
